// Grade team newsletters, newest issue first. Each entry's `grade` is an id from
// ./grades.js.
//
// Files: `type: 'image'` opens in the lightbox; `type: 'pdf'` opens in a new tab
// and shows its `thumb` (a first-page render) as the preview.
//
// A new month: add an issue at the top of the list. No other change is needed;
// each grade links to the newest issue that includes it (see latestIssueByGrade),
// so a grade with no issue this month keeps pointing at its last one.
//
// `archive: true` marks a past school year. Archived issues stay on /newsletters
// but never become a grade's "latest", so a grade with nothing yet this year
// (Kindergarten) shows no newsletter link rather than last year's.

const DIR = '/assets/documents/newsletter';

const issues = [
  {
    id: 'november-2026',
    month: 'November 2026',
    entries: [
      {
        grade: 'pre-k',
        files: [{ name: 'November Newsletter (English & Español)', src: `${DIR}/Pre-K_November_2026.pdf`, thumb: `${DIR}/thumbs/Pre-K_November_2026.webp`, type: 'pdf' }],
      },
      {
        grade: 'kindergarten',
        files: [{ name: 'November Newsletter (English & Español)', src: `${DIR}/Kindergarten_November_2026.pdf`, thumb: `${DIR}/thumbs/Kindergarten_November_2026.webp`, type: 'pdf' }],
      },
      {
        grade: 'grade-1',
        files: [{ name: 'November Newsletter', src: `${DIR}/Grade_1_November_2026.pdf`, thumb: `${DIR}/thumbs/Grade_1_November_2026.webp`, type: 'pdf' }],
      },
      {
        grade: 'grade-2',
        files: [
          { name: 'November Newsletter — English', src: `${DIR}/Grade_2_November_2026_English.webp`, type: 'image' },
          { name: 'November Newsletter — Español', src: `${DIR}/Grade_2_November_2026_Spanish.webp`, type: 'image' },
        ],
      },
      {
        grade: 'grade-3',
        files: [{ name: 'November Newsletter (English & Español)', src: `${DIR}/Grade_3_November_2026.pdf`, thumb: `${DIR}/thumbs/Grade_3_November_2026.webp`, type: 'pdf' }],
      },
      {
        grade: 'grade-4',
        files: [{ name: 'November Newsletter', src: `${DIR}/Grade_4_November_2026.webp`, type: 'image' }],
      },
    ],
  },
  {
    id: 'october-2026',
    month: 'October 2026',
    entries: [
      {
        grade: 'pre-k',
        files: [{ name: 'October Newsletter (English & Español)', src: `${DIR}/Pre-K_October_2026.pdf`, thumb: `${DIR}/thumbs/Pre-K_October_2026.webp`, type: 'pdf' }],
      },
      {
        grade: 'kindergarten',
        files: [{ name: 'October Newsletter', src: `${DIR}/Kindergarten_October_2026.webp`, type: 'image' }],
      },
      {
        grade: 'grade-1',
        files: [{ name: 'October Newsletter', src: `${DIR}/Grade_1_October_2026.pdf`, thumb: `${DIR}/thumbs/Grade_1_October_2026.webp`, type: 'pdf' }],
      },
      {
        grade: 'grade-2',
        files: [
          { name: 'October Newsletter — English', src: `${DIR}/Grade_2_October_2026_English.webp`, type: 'image' },
          { name: 'October Newsletter — Español', src: `${DIR}/Grade_2_October_2026_Spanish.webp`, type: 'image' },
        ],
      },
      {
        grade: 'grade-3',
        files: [{ name: 'October Newsletter (English & Español)', src: `${DIR}/Grade_3_October_2026.pdf`, thumb: `${DIR}/thumbs/Grade_3_October_2026.webp`, type: 'pdf' }],
      },
      {
        grade: 'grade-4',
        files: [{ name: 'October Newsletter', src: `${DIR}/Grade_4_October_2026.webp`, type: 'image' }],
      },
      {
        grade: 'grade-5',
        files: [{ name: 'October Newsletter (English & Español)', src: `${DIR}/Grade_5_October_2026.pdf`, thumb: `${DIR}/thumbs/Grade_5_October_2026.webp`, type: 'pdf' }],
      },
    ],
  },
  {
    id: 'september-2026',
    month: 'September 2026',
    entries: [
      {
        grade: 'pre-k',
        files: [{ name: 'September Newsletter (English & Español)', src: `${DIR}/Pre-K_September_2026.pdf`, thumb: `${DIR}/thumbs/Pre-K_September_2026.webp`, type: 'pdf' }],
      },
      {
        grade: 'grade-1',
        files: [{ name: 'September Newsletter', src: `${DIR}/Grade_1_September_2026.pdf`, thumb: `${DIR}/thumbs/Grade_1_September_2026.webp`, type: 'pdf' }],
      },
      {
        grade: 'grade-2',
        files: [
          { name: 'September Newsletter — English', src: `${DIR}/Grade_2_September_2026_English.webp`, type: 'image' },
          { name: 'September Newsletter — Español', src: `${DIR}/Grade_2_September_2026_Spanish.webp`, type: 'image' },
        ],
      },
      {
        grade: 'grade-3',
        files: [{ name: 'September Newsletter (English & Español)', src: `${DIR}/Grade_3_September_2026.pdf`, thumb: `${DIR}/thumbs/Grade_3_September_2026.webp`, type: 'pdf' }],
      },
      {
        grade: 'grade-4',
        files: [{ name: 'September Newsletter', src: `${DIR}/Grade_4_September_2026.webp`, type: 'image' }],
      },
      {
        grade: 'grade-5',
        files: [{ name: 'September Newsletter', src: `${DIR}/Grade_5_September_2026.pdf`, thumb: `${DIR}/thumbs/Grade_5_September_2026.webp`, type: 'pdf' }],
      },
    ],
  },
  {
    id: 'may-2026',
    month: 'May 2026',
    archive: true,
    note: '2025–26 school year',
    entries: [
      {
        grade: 'pre-k',
        files: [
          { name: 'May Newsletter — Page 1', src: '/assets/images/newsletter1.png', type: 'image' },
          { name: 'May Newsletter — Page 2', src: '/assets/images/newsletter2.png', type: 'image' },
        ],
      },
      {
        grade: 'kindergarten',
        files: [{ name: 'May Newsletter', src: '/assets/images/newsletter3.pdf', thumb: '/assets/images/newsletter3-thumb.webp', type: 'pdf' }],
      },
      {
        grade: 'grade-2',
        files: [
          { name: 'May Newsletter — Page 1', src: '/assets/images/newsletter4.png', type: 'image' },
          { name: 'May Newsletter — Page 2', src: '/assets/images/newsletter5.png', type: 'image' },
        ],
      },
      {
        grade: 'grade-3',
        files: [{ name: 'May Newsletter', src: '/assets/images/newsletter6.pdf', thumb: '/assets/images/newsletter6-thumb.webp', type: 'pdf' }],
      },
    ],
  },
];

// grade id -> the newest non-archived issue that includes that grade. Its block
// on /newsletters carries the anchor id, and /our-classes links to it.
export const latestIssueByGrade = {};
for (const issue of issues) {
  if (issue.archive) continue;
  for (const { grade } of issue.entries) {
    if (!latestIssueByGrade[grade]) latestIssueByGrade[grade] = issue;
  }
}

export default issues;
